import {
    GET_DRIVER,
    GET_DRIVER_SUCCESS,
    GET_DRIVER_FAILURE,
    CREATE_DRIVER,
    CREATE_DRIVER_SUCCESS,
    CREATE_DRIVER_FAILURE,
    UPDATE_DRIVER_PASSWORD,
    UPDATE_DRIVER_PASSWORD_SUCCESS,
    UPDATE_DRIVER_PASSWORD_FAILURE,
    GET_CALENDAR_USER,
    GET_CALENDAR_USER_SUCCESS,
    GET_CALENDAR_USER_FAILURE,
    CREATE_CALENDAR_USER,
    CREATE_CALENDAR_USER_SUCCESS,
    CREATE_CALENDAR_USER_FAILURE,
    UPDATE_CALENDAR_USER_PASSWORD,
    UPDATE_CALENDAR_USER_PASSWORD_SUCCESS,
    UPDATE_CALENDAR_USER_PASSWORD_FAILURE,
    UPDATE_CALENDAR_ACCESS,
    UPDATE_CALENDAR_ACCESS_SUCCESS,
    UPDATE_CALENDAR_ACCESS_FAILURE,
    RESET_TRANSPORT_USER
} from '../constants/transport_user.constants';

export const getDriver = email => ({
    type: GET_DRIVER, email,
});
export const getDriverSuccess = payload => ({
    type: GET_DRIVER_SUCCESS, payload,
});
export const getDriverFailure = () => ({
    type: GET_DRIVER_FAILURE,
});

export const createDriver = data => ({
    type: CREATE_DRIVER, data,
});
export const createDriverSuccess = payload => ({
    type: CREATE_DRIVER_SUCCESS, payload,
});
export const createDriverFailure = () => ({
    type: CREATE_DRIVER_FAILURE,
});

export const updateDriverPassword = data => ({
    type: UPDATE_DRIVER_PASSWORD, data,
});
export const updateDriverPasswordSuccess = () => ({
    type: UPDATE_DRIVER_PASSWORD_SUCCESS,
});
export const updateDriverPasswordFailure = () => ({
    type: UPDATE_DRIVER_PASSWORD_FAILURE,
});


export const getCalendarUser = email => ({
    type: GET_CALENDAR_USER, email,
});
export const getCalendarUserSuccess = payload => ({
    type: GET_CALENDAR_USER_SUCCESS, payload,
});
export const getCalendarUserFailure = () => ({
    type: GET_CALENDAR_USER_FAILURE,
});

export const createCalendarUser = data => ({
    type: CREATE_CALENDAR_USER, data,
});
export const createCalendarUserSuccess = payload => ({
    type: CREATE_CALENDAR_USER_SUCCESS, payload,
});
export const createCalendarUserFailure = () => ({
    type: CREATE_CALENDAR_USER_FAILURE,
});

export const updateCalendarUserPassword = data => ({
    type: UPDATE_CALENDAR_USER_PASSWORD, data,
});
export const updateCalendarUserPasswordSuccess = () => ({
    type: UPDATE_CALENDAR_USER_PASSWORD_SUCCESS,
});
export const updateCalendarUserPasswordFailure = () => ({
    type: UPDATE_CALENDAR_USER_PASSWORD_FAILURE,
});

export const updateCalendarAccess = data => ({
    type: UPDATE_CALENDAR_ACCESS, data
});
export const updateCalendarAccessSuccess = () => ({
    type: UPDATE_CALENDAR_ACCESS_SUCCESS,
});
export const updateCalendarAccessFailure = () => ({
    type: UPDATE_CALENDAR_ACCESS_FAILURE,
});

export const resetTransportUser = () => ({
    type: RESET_TRANSPORT_USER
});


// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/redux/actions/transport_user.actions.js